import { Box, BoxProps } from '@mui/material'

function CenteredPage({ children, ...props }: BoxProps) {
  return <Box {...props} height="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">{children}</Box>
}

export default CenteredPage
